import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const useClasses = makeStyles((theme) => {
  return {
    iconContainer: {
      borderRadius: 8,
      padding: theme.spacing(1),
      '&:hover $icon': {
        color: theme.palette.info.main,
      },
    },
    icon: {
    },
  };
});

const AppIconView = (props) => {
  const classes = useClasses();

  if (props.disabled) {
    return (
      <IconButton className={ classes.iconContainer } { ...props } aria-label='view'>
        <VisibilityIcon className={ classes.icon } />
      </IconButton>
    );
  }

  return (
    <Tooltip title='View' aria-label='view'>
      <IconButton className={ classes.iconContainer } { ...props } aria-label='view'>
        <VisibilityIcon className={ classes.icon } />
      </IconButton>
    </Tooltip>
  );
};

export default AppIconView;
